export default __webpack_public_path__ + "static/media/Twitter.5d191daf.svg";